module.exports = __webpack_public_path__ + "static/media/camera-icon.980362db.svg";